import api from '@a/config';

const path = 'v1/werkzeug/gruppe';

export default {
  get: () => api.get(path),
  getById: (id) => api.get(`${path}/${id}`),
};
